import { useNavigate } from 'react-router-dom';
import { useRouteRef } from '@backstage/core-plugin-api';
import { Page, Header, Content } from '@backstage/core-components';
import { EntityListProvider } from '@backstage/plugin-catalog-react';
import { ScaffolderPageContextMenu } from '@backstage/plugin-scaffolder-react/alpha';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import type { TemplateListPageProps } from '@backstage/plugin-scaffolder/alpha';
import { scaffolderPlugin, scaffolderTranslationRef } from '@backstage/plugin-scaffolder';
import { TemplateList } from './TemplateList';

export const CustomTemplateListPage = (props: TemplateListPageProps) => {
  const { templateFilter, headerOptions } = props;

  const navigate = useNavigate();
  const { t } = useTranslationRef(scaffolderTranslationRef);

  const editorLink = useRouteRef(scaffolderPlugin.routes.edit);
  const actionsLink = useRouteRef(scaffolderPlugin.routes.actions);
  const tasksLink = useRouteRef(scaffolderPlugin.routes.listTasks);
  const templatingExtensionsLink = useRouteRef(scaffolderPlugin.routes.templatingExtensions);

  const scaffolderPageContextMenuProps = {
    onEditorClicked:
      props?.contextMenu?.editor !== false ? () => navigate(editorLink()) : undefined,
    onActionsClicked:
      props?.contextMenu?.actions !== false ? () => navigate(actionsLink()) : undefined,
    onTasksClicked: props?.contextMenu?.tasks !== false ? () => navigate(tasksLink()) : undefined,
    onTemplatingExtensionsClicked:
      props?.contextMenu?.templatingExtensions !== false
        ? () => navigate(templatingExtensionsLink())
        : undefined,
  };

  return (
    <EntityListProvider>
      <Page themeId="home">
        <Header
          pageTitleOverride={t('templateListPage.pageTitle')}
          title={t('templateListPage.title')}
          subtitle={t('templateListPage.subtitle')}
          {...headerOptions}
        >
          <ScaffolderPageContextMenu {...scaffolderPageContextMenuProps} />
        </Header>
        <Content>
          <TemplateList templateFilter={templateFilter} />
        </Content>
      </Page>
    </EntityListProvider>
  );
};
